<template>
  <div class="wrapper keep-margin">
    <!-- Sidebar Holder -->
    <nav id="sidebar" class="mobile-only" :class="menuHidden ? 'active' : ''">
      <div class="sidebar-header">Search Options</div>
      <div class="hits">{{ hits }}</div>
      <div class="container mobile-only">
        <ejs-textbox
          v-model="keywords"
          floatLabelType="Auto"
          placeholder="Search phrase"
          showClearButton="true"
          @change="search"
        ></ejs-textbox>
        <!-- <ejs-multiselect
          floatLabelType="Auto"
          placeholder="Sectors"
          :dataSource="sectors"
          :fields="{ text: 'name', value: 'id' }"
          v-model="selectedSectors"
          @change="search"
        ></ejs-multiselect>
        <ejs-multiselect
          floatLabelType="Auto"
          placeholder="Services"
          :dataSource="services"
          :fields="{ text: 'name', value: 'id' }"
          v-model="selectedServices"
          @change="search"
          @select="search"
        ></ejs-multiselect>
        <ejs-multiselect
          floatLabelType="Auto"
          placeholder="Languages"
          :dataSource="languages"
          :fields="{ text: 'localName', value: 'id' }"
          v-model="selectedLanguages"
          @change="search"
        ></ejs-multiselect> -->
      </div>
      <div class="container pt-4">
        <!-- <div class="row">
          <div class="col-8">Members only</div>
          <div class="col-4 pt-1">
            <toggle-button
              :value="false"
              v-model="membersOnly"
              :disabled="selectedSectors.length > 0 || selectedServices.length > 0"
              :sync="true"
              @change="search"
              :labels="{ checked: 'Yes', unchecked: 'No' }"
              :color="{
                checked: 'green',
                unchecked: 'orange',
                disabled: '#534e4e',
              }"
            />
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-8">Sectors show</div>
          <div class="col-4 pt-1">
            <toggle-button
              :value="true"
              :disabled="selectedSectors.length < 2"
              v-model="sectorsMatchAny"
              :sync="true"
              @change="search"
              :labels="{ checked: 'Any', unchecked: 'All' }"
              :color="{
                checked: 'green',
                unchecked: 'orange',
                disabled: '#534e4e',
              }"
            />
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-8">Services show</div>
          <div class="col-4 pt-1">
            <toggle-button
              :value="true"
              :disabled="selectedServices.length < 2"
              v-model="servicesMatchAny"
              :sync="true"
              @change="search"
              :labels="{ checked: 'Any', unchecked: 'All' }"
              :color="{
                checked: 'green',
                unchecked: 'orange',
                disabled: '#534e4e',
              }"
            />
          </div>
        </div> -->
        <!-- <div class="row">
          <div class="col-8">Languages show</div>
          <div class="col-4 pt-1">
            <toggle-button
              :value="true"
              :disabled="selectedLanguages.length < 2"
              v-model="languagesMatchAny"
              @change="search"
              :labels="{ checked: 'Any', unchecked: 'All' }"
              :color="{
                checked: 'green',
                unchecked: 'orange',
                disabled: '#534e4e',
              }"
            />
          </div>
        </div> -->
      </div>
      <div class="container pt-4">
        <div class="row">
          <div class="col">
            <a class="btn btn-outline-primary btn-sm w-100" @click="reset"
              ><i class="fa fa-refresh" aria-hidden="true"></i> Reset</a
            >
          </div>
          <div class="col">
            <a class="btn btn-primary btn-sm w-100" @click="searchSidebar"
              ><i class="fa fa-search" aria-hidden="true"></i> Search</a
            >
          </div>
        </div>
      </div>
    </nav>

    <!-- Page Content Holder -->
    <div id="content">
      <nav
        class="member-search-navbar navbar navbar-expand-lg navbar-light"
      >
        <div class="container-fluid">
          <button
            type="button"
            id="sidebarCollapse"
            class="navbar-btn mobile-only"
            :class="menuHidden ? 'active' : ''"
            @click="menuHidden = !menuHidden"
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
          <button
            class="desktop-only btn btn-dark d-lg-none ml-auto"
            type="button"
            data-toggle="collapse"
            data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <i class="fas fa-align-justify"></i>
          </button>

          <div class="container-fluid desktop-only" id="navbarSupportedContent">
            <div class="row">
              <div class="col-md-3 d-flex flex-column p-1">
                <!-- <div v-show="!loading" class="members-switch-container">
                  <span class="switch-label">Members only</span>
                  <toggle-button
                    :value="false"
                    v-model="membersOnly"
                    :disabled="selectedSectors.length > 0 || selectedServices.length > 0"
                    :sync="true"
                    @change="search"
                    :labels="{ checked: 'Yes', unchecked: 'No' }"
                    :color="{
                      checked: 'green',
                      unchecked: 'orange',
                      disabled: '#534e4e',
                    }"
                  />
                </div> -->
                <ejs-textbox
                  ref="desktopKeywords"
                  v-model="keywords"
                  floatLabelType="Auto"
                  placeholder="Search phrase"
                  showClearButton="true"
                  @change="search"
                ></ejs-textbox>
              </div>
              <!-- <div class="col-md d-flex flex-column p-1">
                <div
                  class="switch-container"
                  v-show="selectedSectors.length > 1"
                >
                  <toggle-button
                    :value="true"
                    :disabled="selectedSectors.length < 2"
                    v-model="sectorsMatchAny"
                    :sync="true"
                    @change="search"
                    :labels="{ checked: 'Any', unchecked: 'All' }"
                    :color="{
                      checked: 'green',
                      unchecked: 'orange',
                      disabled: '#534e4e',
                    }"
                  />
                </div>
                <ejs-multiselect
                  floatLabelType="Auto"
                  placeholder="Sectors"
                  :dataSource="sectors"
                  :fields="{ text: 'name', value: 'id' }"
                  v-model="selectedSectors"
                  @select="sectorsSelect"
                  @removed="sectorsRemove"
                ></ejs-multiselect>
              </div> -->
              <!-- <div class="col-md d-flex flex-column p-1">
                <div
                  class="switch-container"
                  v-show="selectedServices.length > 1"
                >
                  <toggle-button
                    :value="true"
                    :disabled="selectedServices.length < 2"
                    v-model="servicesMatchAny"
                    :sync="true"
                    @change="search"
                    :labels="{ checked: 'Any', unchecked: 'All' }"
                    :color="{
                      checked: 'green',
                      unchecked: 'orange',
                      disabled: '#534e4e',
                    }"
                  />
                </div>
                <ejs-multiselect
                  floatLabelType="Auto"
                  placeholder="Services"
                  :dataSource="services"
                  :fields="{ text: 'name', value: 'id' }"
                  v-model="selectedServices"
                  @select="servicesSelect"
                  @removed="servicesRemove"
                ></ejs-multiselect>
              </div> -->
              <!-- <div class="col-md-2 d-flex flex-column p-1">
                <div
                  class="switch-container"
                  v-show="selectedLanguages.length > 1"
                >
                  <toggle-button
                    :value="true"
                    :disabled="selectedLanguages.length < 2"
                    v-model="languagesMatchAny"
                    @change="search"
                    :labels="{ checked: 'Any', unchecked: 'All' }"
                    :color="{
                      checked: 'green',
                      unchecked: 'orange',
                      disabled: '#534e4e',
                    }"
                  />
                </div>
                <ejs-multiselect
                  floatLabelType="Auto"
                  placeholder="Languages"
                  :dataSource="languages"
                  :fields="{ text: 'localName', value: 'id' }"
                  v-model="selectedLanguages"
                  @select="languagesSelect"
                  @removed="languagesRemove"
                ></ejs-multiselect>
              </div> -->
              <div class="col-md-auto d-flex flex-column align-self-end" style="padding: 5px">
                <a
                  class="btn btn-link btn-sm"
                  @click="reset"
                  ><i class="fa fa-refresh" aria-hidden="true"></i></a
                >
              </div>
            </div>
          </div>
        </div>
      </nav>
      <div class="results">
        <div v-show="loading" class="w-100 h-100" >
          <div class="w-100 h-100 d-flex justify-content-center align-items-center">
            <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
          </div>
        </div>
        <div v-show="!loading"><MembersList :list="results" /></div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import axios from 'axios'
import { orderBy, filter } from 'lodash'
import { MultiSelectPlugin } from '@syncfusion/ej2-vue-dropdowns'
import { TextBoxPlugin } from '@syncfusion/ej2-vue-inputs'
import { CheckBoxPlugin } from '@syncfusion/ej2-vue-buttons'
// import { ToggleButton } from 'vue-js-toggle-button'
import MembersList from './MembersList'
Vue.use(MultiSelectPlugin)
Vue.use(TextBoxPlugin)
Vue.use(CheckBoxPlugin)
export default {
  name: 'MemberSearch',
  components: {
    MembersList,
    // ToggleButton,
  },
  props: {
    endpoint: {
      type: String,
      default: '/api/v1/',
    },
    language: {
      type: String,
      default: 'en',
    },
  },
  data: function () {
    return {
      loading: false,
      menuHidden: false,
      keywords: '',
      sectors: [],
      services: [],
      languages: [],
      membersOnly: false,
      selectedSectors: [],
      selectedServices: [],
      selectedLanguages: [],
      sectorsMatchAny: true,
      servicesMatchAny: true,
      languagesMatchAny: true,
      apiCount: 0,
      results: [],
    }
  },
  //  computed: {},
  async mounted() {
    await this.load()
    this.search()
  },
  computed: {
    hits() {
      if (this.results.length === 0) {
        return 'No agencies found'
      }
      return this.results.length === 1
        ? 'Found one agency'
        : `Found ${this.results.length} agencies`
    },
  },
  methods: {
    load: async function () {
      try {
        this.loading = true
        const res = await axios.get(
          `${this.endpoint}member-search-lists?cb=${Date.now()}`
        )
        this.services = res.data.services
        this.sectors = res.data.sectors
        const languages = res.data.languages
        languages.forEach((e) => (e.localName = e.translations[this.language]))
        this.languages = orderBy(
          languages,
          [(each) => each.localName.toLowerCase()],
          ['asc']
        )
      } catch(err) {
        // report?
      } finally {
        this.loading = false
      }
    },
    searchSidebar() {
      this.menuHidden = !this.menuHidden
      this.search()
    },
    sectorsSelect(e) {
      const itemId = e.itemData.id
      if (this.selectedSectors.indexOf(itemId) == -1) {
        this.selectedSectors.push(itemId)
      }
      this.search()
    },
    sectorsRemove(e) {
      const itemId = e.itemData.id
      if (this.selectedSectors.indexOf(itemId) != -1) {
        let filtered = filter(this.selectedSectors, (item) => {
          return item !== itemId
        })
      this.selectedSectors = filtered
      this.search()
      }
    },
    servicesSelect(e) {
      const itemId = e.itemData.id
      if (this.selectedServices.indexOf(itemId) == -1) {
        this.selectedServices.push(itemId)
      }
      this.search()
    },
    servicesRemove(e) {
      const itemId = e.itemData.id
      if (this.selectedServices.indexOf(itemId) != -1) {
        let filtered = filter(this.selectedServices, (item) => {
          return item !== itemId
        })
      this.selectedServices = filtered
      this.search()
      }
    },
    languagesSelect(e) {
      const itemId = e.itemData.id
      if (this.selectedLanguages.indexOf(itemId) == -1) {
        this.selectedLanguages.push(itemId)
      }
      this.search()
    },
    languagesRemove(e) {
      const itemId = e.itemData.id
      if (this.selectedLanguages.indexOf(itemId) != -1) {
        let filtered = filter(this.selectedLanguages, (item) => {
          return item !== itemId
        })
      this.selectedLanguages = filtered
      this.search()
      }
    },
    search: async function () {
      if(this.selectedSectors.length || this.selectedServices.length) {
        this.membersOnly = true
      }
      try {
        this.loading = true
        this.apiCount += 1
        axios
          .post(`${this.endpoint}member-search`, {
            apiCount: this.apiCount,
            keywords: JSON.stringify(
              this.keywords
                .split(' ')
                .map((e) => e.trim())
                .filter((e) => e !== '')
            ),
            membersOnly: this.membersOnly,
            sectors: this.selectedSectors.join(','),
            services: this.selectedServices.join(','),
            languages: this.selectedLanguages.join(','),
            sectorsMatch: this.sectorsMatchAny ? '' : 'ALL',
            servicesMatch: this.servicesMatchAny ? '' : 'ALL',
            languagesMatch: this.languagesMatchAny ? '' : 'ALL',
          })
          .then((response) => {
            const responseCount = JSON.parse(response.config.data).apiCount
            
            if (response.data.success && responseCount === this.apiCount) {
              const companies = response.data.data
              companies.forEach(company => {
                company.slug = this.slug(company.name)
              })
              this.results = companies
            }
          })
      } catch(err) {
        // report?
      } finally {
        this.loading = false
      }
    },

    slug(name) {
      // Convert name to slug. Spaces are turned into underscores, everything else is URL component encoded
      // This will fail if a company name contains _ (unlikely)
      // If this happens, we could escape the genuine _ or add a slug field to the company table

      return encodeURIComponent(name.replaceAll(' ', '_'))
    },

    reset() {
      this.keywords = ''
      this.selectedSectors = []
      this.selectedServices = []
      this.selectedLanguages = []
      this.membersOnly = false
      this.sectorsMatchAny = true
      this.servicesMatchAny = true
      this.languagesMatchAny = true
      this.results = []
      this.search()
    },
  },
}
</script>
<style>
@import '../../node_modules/@syncfusion/ej2-base/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-dropdowns/styles/bootstrap.css';
@import '../../node_modules/@syncfusion/ej2-inputs/styles/bootstrap.css';

.btn-link {
  color: #33b4bf !important;
}
.btn-primary {
  background-color: #33b4bf !important;
  border-color: #33b4bf !important;
}
.btn-outline-primary {
  background-color: transparent;
  border-color: #33b4bf !important;
  color: #33b4bf !important;
  border: 1px #33b4bf solid!important
}
.btn-outline-primary:hover {
  background-color: #33b4bf !important;
  border-color: #33b4bf !important;
  color: #fff !important;
}
/* ---------------------------------------------------
    SIDEBAR STYLE
----------------------------------------------------- */

.wrapper {
  display: flex;
  width: 100%;
  align-items: stretch;
  perspective: 1500px;
}

#sidebar {
  position: absolute;
  min-width: 100%;
  max-width: 270px;
  padding: 0 8px;
  transition: all 0.6s cubic-bezier(0.945, 0.02, 0.27, 0.665);
  transform-origin: bottom left;
  height: 100%;
  background: white;
  opacity: 1;
  box-shadow: 14px 0px 20px -16px rgba(0, 0, 0, 0.5);
  z-index: 9990;
}

#sidebar.active {
  margin-left: -270px;
  transform: rotateY(100deg);
  opacity: 0;
}

#sidebar .sidebar-header {
  padding: 76px 20px 0px 10px;
  font-size: 1.2em;
  font-weight: bold;
}
#sidebar .hits {
  padding: 6px 0 7px 10px;
  font-size: 0.8em;
}

/* ---------------------------------------------------
    CONTENT STYLE
----------------------------------------------------- */
.member-search-navbar {
  padding: 0 0 8px 0;
}
#content {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  transition: all 0.3s;
}
.members-switch-container {
  position: absolute;
  margin-top: 74px;
  white-space: nowrap;
  z-index: 9999;
}
.switch-container {
  position: absolute;
  align-self: flex-end;
  top: -2px;
}
.switch-container .vue-js-switch {
  margin-bottom: 4px;
}
.switch-label {
  font-size: 12px;
  font-weight: 700;
  margin-right: 8px;
  margin-bottom: 4px;
  line-height: 16.8px;
  vertical-align: middle;
  font-family: 'Helvetica Neue', 'Helvetica', 'Arial', sans-serif,
    '-apple-system', 'BlinkMacSystemFont';
}
.results {
  overflow-x: hidden;
  flex-grow: 1;
}

#sidebarCollapse {
  width: 40px;
  height: 40px;
  background: transparent;
  border: none;
  margin-top: 23px;
  margin-right: 8px;
  cursor: pointer;
  z-index: 9999;
}

#sidebarCollapse span {
  width: 20px;
  height: 2px;
  margin: 0 auto;
  display: block;
  background: #555;
  transition: all 0.8s cubic-bezier(0.81, -0.33, 0.345, 1.375);
  transition-delay: 0.2s;
}

#sidebarCollapse span:first-of-type {
  transform: rotate(45deg) translate(2px, 2px);
}
#sidebarCollapse span:nth-of-type(2) {
  opacity: 0;
}
#sidebarCollapse span:last-of-type {
  transform: rotate(-45deg) translate(1px, -1px);
}

#sidebarCollapse.active span {
  transform: none;
  opacity: 1;
  margin: 5px auto;
}

/* ---------------------------------------------------
    MEDIAQUERIES
----------------------------------------------------- */
@media (max-width: 991px) {
  .desktop-only {
    display: none !important;
  }
  #sidebar {
    margin-left: -270px;
    transform: rotateY(90deg);
  }
  #sidebar.active {
    margin-left: 0;
    transform: none;
    opacity: 1;
  }
  #sidebarCollapse span:first-of-type,
  #sidebarCollapse span:nth-of-type(2),
  #sidebarCollapse span:last-of-type {
    transform: none;
    opacity: 1;
    margin: 5px auto;
  }
  #sidebarCollapse.active span {
    margin: 0 auto;
  }
  #sidebarCollapse.active span:first-of-type {
    transform: rotate(45deg) translate(2px, 2px);
  }
  #sidebarCollapse.active span:nth-of-type(2) {
    opacity: 0;
  }
  #sidebarCollapse.active span:last-of-type {
    transform: rotate(-45deg) translate(1px, -1px);
  }
}
@media (min-width: 992px) {
  .mobile-only {
    display: none !important;
  }
}
</style>
